import React, { useState, useEffect } from 'react';
import appSettings from './app_settings';

import {
    AppLayout, Spinner, ContentLayout,
    Container, Header, Box, SpaceBetween, ExpandableSection, Modal, ColumnLayout, Button, Alert,
    Checkbox, Table, FormField, Input
} from '@amzn/awsui-components-react';

import '../../index.scss';
import { useSelector, useDispatch } from 'react-redux'

import './styles.scss'

import { useHistory } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import SideNav from './SideNav';
import { getFriscoGroupsForAppId, updateGroups } from '../Templates/Utils/AppActivityUtils';
import { isCorpAdmin } from '../Templates/Utils/Permissions';
import CustomGroupsForAppsWithReloadNotifiers from '../Templates/components/CustomGroupsForAppsWithReloadNotifiers';
import CustomSelectAlias from '../Templates/components/CustomSelectAlias';
import { useSuggestedLogins } from 'src/hooks/useSuggestedLogins';
import { createPreference, listPreference, updatePreference, getAppDeliverablesLockStatus, setAppDeliverablesLockStatus, getNonAmazonAliases, addNonAmazonAlias, deleteNonAmazonAlias } from 'src/utilities/AppSyncPlusAPIs';

// Component ServiceHomepage is a skeleton of a service's homepage using AWS-UI React components.
export default (props) => {

    const dispatch = useDispatch();
    const { suggestedLogins, aliasesLoading: suggestedLoginsLoading, getSuggestedLoginsCaller } = useSuggestedLogins();
    const currentStage = useSelector((globalState) => globalState.auth.currentStage)
    const history = useHistory();
    const [NavOpen, setNavOpen] = useState(false);
    const [showLoadingIcon, setShowLoadingIcon] = useState(true);
    const userId = useSelector((globalState) => globalState.auth.userId);
    const [isAdmin, setIsAdmin] = useState(false)
    const [toolsOpen, setToolsOpen] = useState(false);
    const [groups, setGroups] = useState([]);
    const [approvers, setApprovers] = useState([]);
    const [notificationSubscribers, setNotificationSubscribers] = useState([]);
    const [reloadNotifiers, setReloadNotifiers] = useState({})
    const [loaders, setLoaders] = useState({})
    const [errorMessages, setErrorMessages] = useState({})
    const [tags, setTags] = useState([]);
    const [creatorAlias, setCreatorAlias] = useState([]);
    const [preference, setPreference] = useState({})
    const [disableAllDeliverables, setDisableAllDeliverables] = useState(false)
    const [deliverablesLoader, setDeliverablesLoader] = useState(false)
    const [deliverablesError, setDeliverablesError] = useState('')
    const [nonAmazonAliases, setNonAmazonAliases] = useState([])
    const [aliasesLoader, setAliasesLoader] = useState(false)
    const [aliasesError, setAliasesError] = useState('')
    const [newAliasName, setNewAliasName] = useState('')
    const [newAliasEmail, setNewAliasEmail] = useState('')
    const [addAliasLoader, setAddAliasLoader] = useState(false)

    const FIELD_NAMES = {
        WORKSTREAMS: 'WORKSTREAMS'
    }
    const ALIAS_TYPES = {
        FRISCO_CORP_REPORTING_ADMIN: "FRISCO_CORP_REPORTING_ADMIN",
        FRISCO_CORP_REPORTING_ADMIN_NOTIFY: "FRISCO_CORP_REPORTING_ADMIN_NOTIFY",
        FRISCO_CORP_REPORTING_CREATOR_ALIAS: "FRISCO_CORP_REPORTING_CREATOR_ALIAS"
    }
    useEffect(() => {
        setViewItems()
        return () => {
            // this now gets called when the component unmounts
        };
    }, [currentStage]);


    const setViewItems = async () => {
        let accessPerms = await isCorpAdmin(userId, appSettings[currentStage].appId, currentStage)
        setIsAdmin(accessPerms?.admin)
        setShowLoadingIcon(false)
        loadGroups()
        getAppDeliverablesLockStatus(appSettings[currentStage].appId,
            (result) => setDisableAllDeliverables(result?.data?.getAppDeliverablesLockStatus?.is_locked ?? false),
            () => {}
        )
        loadNonAmazonAliases()
    }

    const loadNonAmazonAliases = () => {
        setAliasesLoader(true)
        setAliasesError('')
        getNonAmazonAliases(
            (result) => {
                let data = result?.data?.getNonAmazonAliases
                if (typeof data === 'string') {
                    data = JSON.parse(data)
                }
                setNonAmazonAliases(data ?? [])
                setAliasesLoader(false)
            },
            () => {
                setAliasesLoader(false)
                setAliasesError('Could not load non-Amazon aliases')
            }
        )
    }

    const addAlias = () => {
        setAddAliasLoader(true)
        setAliasesError('')
        addNonAmazonAlias(newAliasName.trim(), newAliasEmail.trim(), userId,
            () => {
                setAddAliasLoader(false)
                setNewAliasName('')
                setNewAliasEmail('')
                loadNonAmazonAliases()
            },
            () => {
                setAddAliasLoader(false)
                setAliasesError('Could not add alias. Check that the email domain is approved.')
            }
        )
    }

    const removeAlias = (alias) => {
        setAliasesLoader(true)
        setAliasesError('')
        deleteNonAmazonAlias(alias,
            () => loadNonAmazonAliases(),
            () => {
                setAliasesLoader(false)
                setAliasesError('Could not delete alias')
            }
        )
    }

    const loadGroups = () => {
        getFriscoGroupsForAppId(appSettings[currentStage].appId,
            function onSuccess(result) {
                setGroups(result.data.getFRISCOGroups)
                setReloaders(FIELD_NAMES.WORKSTREAMS, true)
                setLoader(FIELD_NAMES.WORKSTREAMS, false)
                setReloaders(FIELD_NAMES.WORKSTREAMS, true)
            }, function onFailure(result) {

            })
    }



    const refresh = async (key) => {
        setError(key, "")
        setLoader(key, true)
        setReloaders(key, false)
        if (key == FIELD_NAMES.WORKSTREAMS) {
            loadGroups()
        }
    }

    const setLoader = (key, value) => {
        let obj = {}
        obj[key] = value
        setLoaders(prevState => {
            return { ...prevState, ...obj };
        });
    }

    const setReloaders = (key, value) => {
        let obj = {}
        obj[key] = value
        setReloadNotifiers(prevState => {
            return { ...prevState, ...obj };
        });

    }
    const updateValue = (fieldName, value) => {
        if (fieldName == FIELD_NAMES.WORKSTREAMS) {
            setGroups(value)
        } else if (fieldName == FIELD_NAMES.CREATOR_ALIAS) {
            setCreatorAlias(value)
        }
    }
    const getSelectFieldValues = (fieldName, subKey = null) => {
        if (fieldName == FIELD_NAMES.WORKSTREAMS) {
            return groups
        } else if (fieldName == FIELD_NAMES.APPROVERS) {
            return approvers
        } else if (fieldName == FIELD_NAMES.NOTIFICATION_SUBSCRIBERS) {
            return notificationSubscribers
        }else if (fieldName == FIELD_NAMES.TAGS) {
            return tags
        }else if (fieldName == FIELD_NAMES.CREATOR_ALIAS) {
            return creatorAlias
        }
        return []
    }
    const updateWorkstreams = () => {
        setLoader(FIELD_NAMES.WORKSTREAMS, true)
        setReloaders(FIELD_NAMES.WORKSTREAMS, false)
        updateGroups(appSettings[currentStage].appId, groups,function onSucess(result) {
            refresh(FIELD_NAMES.WORKSTREAMS)
        }, function onFailure(result) {
            refresh(FIELD_NAMES.WORKSTREAMS, true)
            setError(FIELD_NAMES.WORKSTREAMS, "Could not update the groups")
        })
    }

    const saveDeliverablesLockStatus = () => {
        setDeliverablesLoader(true)
        setDeliverablesError('')
        setAppDeliverablesLockStatus(appSettings[currentStage].appId, disableAllDeliverables,
            () => setDeliverablesLoader(false),
            () => {
                setDeliverablesLoader(false)
                setDeliverablesError('Could not update deliverables lock status')
            }
        )
    }

    const setError = (key, value) => {
        let obj = {}
        obj[key] = value
        setErrorMessages(prevState => {
            return { ...prevState, ...obj };
        });
    }

    const adminContent = (
        <div className="mainPage">
            <ContentLayout
                headerVariant="high-contrast"
                header={
                    <SpaceBetween size="m">
                        <Header
                            variant="h1"
                            description="Admin panel for editing the configuration"

                        >
                            Admin panel
                        </Header>
                    </SpaceBetween>
                }
            >
                <Container>
                    <ColumnLayout columns={2}>
                        <ExpandableSection
                            variant="container"
                            defaultExpanded={false}
                            headerText={"Workstreams"}
                            headerActions={<Button iconName="refresh" variant="icon" onClick={() => {
                                refresh(FIELD_NAMES.WORKSTREAMS)
                            }}></Button>}
                        >
                            {loaders && loaders[FIELD_NAMES.WORKSTREAMS] ? <Box>
                                <span>Please wait...</span> <Spinner />
                            </Box> : ''}

                            <SpaceBetween direction='vertical'>
                                <span className="small_grey_text_italics">
                                    Adding/updating a workstream
                                </span>

                                {errorMessages[FIELD_NAMES.WORKSTREAMS] ? <Box>
                                    <span className="errorMessage">{errorMessages[FIELD_NAMES.WORKSTREAMS]}</span>
                                </Box> : ''}

                                {
                                    groups ?
                                        <>
                                            <CustomGroupsForAppsWithReloadNotifiers reloadNotifiers={reloadNotifiers} setReloadNotifier={setReloaders}
                                                field={FIELD_NAMES.WORKSTREAMS} updateValue={updateValue} getValues={getSelectFieldValues} appId={appSettings[currentStage].appId}></CustomGroupsForAppsWithReloadNotifiers>
                                            <Box float="right">
                                                <Button variant="primary" disabled={loaders[FIELD_NAMES.WORKSTREAMS] ? true : false} onClick={() => updateWorkstreams()}>Save</Button>
                                            </Box>
                                        </> : <></>
                                }

                            </SpaceBetween>
                        </ExpandableSection>

                        <ExpandableSection
                            variant="container"
                            defaultExpanded={false}
                            headerText="Deliverables"
                        >
                            <SpaceBetween direction="vertical" size="m">
                                <span className="small_grey_text_italics">
                                    Lock all deliverables across SEC Central
                                </span>
                                {deliverablesError ? <span className="errorMessage">{deliverablesError}</span> : ''}
                                <Checkbox
                                    checked={disableAllDeliverables}
                                    onChange={({ detail }) => setDisableAllDeliverables(detail.checked)}
                                >
                                    Lock all deliverables
                                </Checkbox>
                                <Box float="right">
                                    <Button variant="primary" loading={deliverablesLoader} onClick={saveDeliverablesLockStatus}>Save</Button>
                                </Box>
                            </SpaceBetween>
                        </ExpandableSection>

                        <ExpandableSection
                            variant="container"
                            defaultExpanded={false}
                            headerText="Non-Amazon aliases"
                            headerActions={<Button iconName="refresh" variant="icon" onClick={loadNonAmazonAliases}></Button>}
                        >
                            <SpaceBetween direction="vertical" size="m">
                                <span className="small_grey_text_italics">
                                    Manage non-Amazon subsidiary email addresses that receive digest emails
                                </span>
                                {aliasesError ? <span className="errorMessage">{aliasesError}</span> : ''}

                                <ColumnLayout columns={2}>
                                    <FormField label="Alias">
                                        <CustomSelectAlias
                                            field="alias"
                                            getValue={() => newAliasName || null}
                                            updateValue={(field, value) => setNewAliasName(value?.[0] ?? '')}
                                            options={suggestedLogins}
                                            getOptions={getSuggestedLoginsCaller}
                                            aliasesLoading={suggestedLoginsLoading}
                                        />
                                    </FormField>
                                    <FormField label="Email">
                                        <Input
                                            value={newAliasEmail}
                                            placeholder="e.g. user@zoox.com"
                                            onChange={({ detail }) => setNewAliasEmail(detail.value)}
                                        />
                                    </FormField>
                                </ColumnLayout>
                                <Box float="right">
                                    <Button
                                        variant="primary"
                                        loading={addAliasLoader}
                                        disabled={!newAliasName.trim() || !newAliasEmail.trim()}
                                        onClick={addAlias}
                                    >
                                        Add alias
                                    </Button>
                                </Box>

                                <Table
                                    loading={aliasesLoader}
                                    loadingText="Loading aliases..."
                                    items={nonAmazonAliases}
                                    columnDefinitions={[
                                        { id: 'alias', header: 'Alias', cell: (item) => item.alias },
                                        { id: 'email', header: 'Email', cell: (item) => item.email },
                                        { id: 'domain', header: 'Domain', cell: (item) => item.domain },
                                        { id: 'created_by', header: 'Created by', cell: (item) => item.created_by },
                                        {
                                            id: 'actions', header: 'Actions', cell: (item) => (
                                                <Button variant="inline-link" iconName="remove" onClick={() => removeAlias(item.alias)}>Delete</Button>
                                            )
                                        }
                                    ]}
                                    empty={<Box textAlign="center" color="inherit">No non-Amazon aliases</Box>}
                                    variant="embedded"
                                />
                            </SpaceBetween>
                        </ExpandableSection>

                    </ColumnLayout>
                </Container>
            </ContentLayout>
        </div>
    )
    const loaderView = (
        <Box>
            <Spinner />
        </Box>
    )

    const Content = (
        <>
            {
                showLoadingIcon ? <Box>{loaderView}</Box> :
                    isAdmin ? <Box>{adminContent}</Box> : <Alert
                        statusIconAriaLabel="Error"
                        type="error"
                        header="Access denied"
                    >
                        No access to view admin panel
                    </Alert>
            }

        </>
    )


    return (
        <AppLayout
            disableContentPaddings={true}
            content={Content}
            navigation={<SideNav activeHref={`/CorpReportingHome/admin`} id={appSettings[currentStage].appId} isAdmin={isAdmin} />}
            contentType="default"
            navigationOpen={NavOpen}
            onNavigationChange={() => {
                setNavOpen(!NavOpen);
            }}
            toolsHide={true}
            toolsOpen={toolsOpen}
            onToolsChange={() => { setToolsOpen(!toolsOpen) }}
            headerVariant="high-contrast"
        />
    );

};


